module.exports = __webpack_public_path__ + "static/assets/6bf0f42484df5f8328a950481f12e858.svg";